var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTvIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 23",
    style: {
      enableBackground: "new 0 0 32 23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.5,18.4H2.5c-1.4,0-2.5-1.1-2.5-2.5V2.5C0,1.1,1.1,0,2.5,0h26.9C30.9,0,32,1.1,32,2.5v13.4 C32,17.3,30.9,18.4,29.5,18.4z M2.5,2.3c-0.1,0-0.3,0.1-0.3,0.3v13.4c0,0.1,0.1,0.3,0.3,0.3h26.9c0.1,0,0.3-0.1,0.3-0.3V2.5 c0-0.1-0.1-0.3-0.3-0.3H2.5z M7.1,21.9c0,0,2-1.4,8.9-1.4s8.8,1.4,8.8,1.4 M24.8,23c-0.2,0-0.5-0.1-0.7-0.2c0,0-1.9-1.2-8.1-1.2 c-6.2,0-8.3,1.2-8.3,1.2c-0.5,0.3-1.2,0.2-1.6-0.3c-0.3-0.5-0.2-1.2,0.3-1.5c0.2-0.2,2.5-1.6,9.5-1.6c7,0,9.2,1.4,9.4,1.6 c0.5,0.4,0.6,1.1,0.2,1.6C25.5,22.8,25.1,23,24.8,23z M19.8,7l-3.2-2.8c-0.4-0.4-1.1-0.4-1.5,0L11.9,7c-0.5,0.4-0.5,1.1-0.1,1.6 c0.4,0.5,1.1,0.5,1.6,0.1l1.4-1.2v5.7c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1V7.6l1.3,1.1C18.6,8.9,18.8,9,19.1,9 c0.3,0,0.6-0.1,0.9-0.4C20.4,8.2,20.3,7.4,19.8,7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvIcon);
export default __webpack_public_path__ + "static/media/TvIcon.64381c66.svg";
export { ForwardRef as ReactComponent };